import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD, API_POST_METHOD, API_PUT_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchJrReports(moduleId) {
	let JrReports = [];

	try {
		const content = {
			method: API_GET_METHOD,
			url: `/reports/jrreports/labhero/${moduleId}`,
		};
		const response = await axiosLabAPI(content);
		const { data } = await response;

		JrReports = data;
	} catch (e) {
	// 	const status = (e.response && e.response.status) || 500;
    // showMessage(status);

		JrReports = [];
	}

	console.log(JrReports);

	return JrReports;
}
